module.exports = __webpack_public_path__ + "static/media/brand-white.1b34d1ef.svg";